export default "__VITE_ASSET__CisL98j7__"